import * as React from 'react';
import ReactTable from 'react-table';
import { Column } from 'react-table';

export interface VendorInfoTradeTableComponentProperties {}

export class VendorInfoTradeTableComponent extends React.Component<VendorInfoTradeTableComponentProperties> {
  render() {
    const columns: Column[] = [
      {
        accessor: 'trade',
        Header: 'Trade',
        sortable: true
      },
      {
        accessor: '',
        Header: 'Dispatched Swo',
        maxWidth: 300,
        sortable: false
      },
      {
        accessor: '',
        Header: 'Redispatched %',
        sortable: false
      },

      {
        accessor: '',
        Header: 'Avg Gross',
        sortable: false
      },

      {
        accessor: '',
        Header: 'Vendor Group',
        sortable: false
      }
    ];
    return (
      <div>
        <ReactTable
          onPageChange={() => {
            Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
              element.scrollTop = 0;
            });
          }}
          className="-striped -highlight"
          columns={columns}
          // data={{} as VendorTradeTableComponentProperties}
          defaultPageSize={10}
          // loading={this.props.propertyManagerLoading}
          manual={true}
          // onFetchData={this.handleFetchData}
          // pages={this.props.propertyManagerPageCount}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-info/vendor-info-trade-table.component.tsx